import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider as ApolloHooksProvider } from "react-apollo-hooks";
import { BrowserRouter, Switch, Route, Redirect} from "react-router-dom";
import {ApolloClient} from 'apollo-client';

import {InMemoryCache} from 'apollo-cache-inmemory';
import {HttpLink} from 'apollo-link-http';
import { ApolloLink, split } from 'apollo-link';
import {ApolloProvider} from 'react-apollo';

import { getMainDefinition } from 'apollo-utilities';

import { WebSocketLink } from 'apollo-link-ws';

import '../components/GlobalCss.css'
import '../fonts/fonts.css';
import '../fonts/montserrat/montserrat.css';
import './index.css';
import HeaderAll from "../components/HeaderAll/HeaderAll";
import IndexMain from "../components/AAGlobal/IndexMain/IndexMain";
import PersonalPage from "../components/AAGlobal/PersonalPage/PersonalPage";
import ReferalPage from "../components/AAGlobal/ReferalPage/ReferalPage";
import ReferalStatisticPage from "../components/AAGlobal/ReferalStatisticPage/ReferalStatisticPage";
import GuestStatisticPage from "../components/AAGlobal/GuestStatisticPage/GuestStatisticPage";
import WithdrawalPage from "../components/AAGlobal/WithdrawalPage/WithdrawalPage";
import LoginControl from "../components/NoAuth/NoAuth";
import withSession from "../components/withSession";
import {GET_ALL_TEXTS, SUB_BUY_UNITEN, GET_CURRENT_USER_AGENT, GET_STEAKING_COINS, GET_USER_KYC } from "../queries";
import {SERVER_ADDRESS, WS_SERVER_ADDRESS} from "../../../env";
import Query from "react-apollo/Query";
import Posts from "../components/AAGlobal/Posts/Posts";
import CurrentNew from "../components/AAGlobal/Posts/CurrentNew/CurrentNew";
import Steaking from "../components/AAGlobal/Steaking/Steaking";
import CurrentSteak from "../components/AAGlobal/Steaking/CurrentSteak";
import KYC_main from "../components/AAGlobal/KYC/KYC_main";

import BronzeOffer2 from "../components/AAGlobal/Offers/BronzeOffer2";

const cache = new InMemoryCache();

const request = operation => {
    const token = localStorage.getItem('token');
    operation.setContext({
        headers: {
            authorization: token
        }
    });
};

const httpLink = new HttpLink({
    uri: SERVER_ADDRESS,
    headers: {
        authorization: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    },
});

const wsLink = new WebSocketLink({
    uri: WS_SERVER_ADDRESS,
    options: {
        //reconnect: true,
        reconnect: false,
    },
});

const terminatingLink = split(
    ({ query }) => {
        const { kind, operation } = getMainDefinition(query);
        return (
            kind === 'OperationDefinition' && operation === 'subscription'
        );
    },
    wsLink,
    httpLink,
);

const link = ApolloLink.from([terminatingLink]);

const client = new ApolloClient({
    cache,
    link : link,

});

const getAllTextMap2 = {};

export class App extends React.Component {
    constructor(props){
        super(props);
        //console.log(props);
        this.state = {
            AllSessionWithSubscription : (this.props.session.getCurrentUser ? this.props.session.getCurrentUser : ''),
        }}

    componentDidMount() {
        this.props.subscribeToMore({
            document: SUB_BUY_UNITEN,
            updateQuery: (prev, { subscriptionData }) => {
                if (!subscriptionData.data) return prev;
                this.setState({AllSessionWithSubscription : subscriptionData.data.SubBuyUniten});
                return {
                    allMessages: [
                        subscriptionData.data.SubBuyUniten,prev
                    ],
                };
            },
        });
    }

    render (){
        return(
    <React.Fragment>
        <div>
            <HeaderAll session={this.state.AllSessionWithSubscription}/>

        </div>
            <Switch>
                <Route exact path="/" render={() =>
                    <Query query={GET_ALL_TEXTS}>
                        {({data, loading, error}) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;

                            data.getAllTexts.forEach(function (user) {
                                getAllTextMap2[user.TextName] = user.TextValue;
                            });
                            return <IndexMain session={this.state.AllSessionWithSubscription} AllText={getAllTextMap2}/>;
                        }
                        }
                    </Query>

                }/>
                <Route exact path="/personal" render={() =>
                    <Query query = {GET_ALL_TEXTS} >
                        {({ data, loading, error}) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;

                            data.getAllTexts.forEach(function(user) {getAllTextMap2[user.TextName] =  user.TextValue;});
                            return <PersonalPage session={this.state.AllSessionWithSubscription} AllText={getAllTextMap2}/>;
                        }
                        }
                    </Query>
                }/>
                <Route exact path="/kyc" render={() =>
                    <Query query = {GET_ALL_TEXTS} >
                        {({ data, loading, error}) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;

                            data.getAllTexts.forEach(function(user) {getAllTextMap2[user.TextName] = user.TextValue;});
                            
                            return <KYC_main session={this.state.AllSessionWithSubscription} AllText={getAllTextMap2}/>;                            
                        }}
                    </Query>
                }/>
                <Route exact path="/referal"  render={() =>
                    <Query query={GET_ALL_TEXTS}>
                        {({data, loading, error}) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;

                            data.getAllTexts.forEach(function (user) {
                                getAllTextMap2[user.TextName] = user.TextValue;
                            });
                            return <ReferalPage session={this.state.AllSessionWithSubscription} AllText={getAllTextMap2}/>;
                        }
                        }
                    </Query>

                }/>
                <Route exact path="/referalstatistic"  render={() =>
                    <Query query={GET_CURRENT_USER_AGENT}>
                        {({data, loading, error}) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;
                            return <ReferalStatisticPage session={this.state.AllSessionWithSubscription} UsersAgent={data.getCurrentUserAgent}/>;
                        }
                        }
                    </Query>

                }/>
                <Route exact path="/myguest" render={() =>
                    <Query query={GET_CURRENT_USER_AGENT}>
                        {({ data, loading, error }) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;                                
                            return <GuestStatisticPage session={this.state.AllSessionWithSubscription} UsersAgent={data.getCurrentUserAgent} />;
                        }
                        }
                    </Query>

                } />
                <Route exact path="/withdrawal" render={() =>
                    <Query query={GET_ALL_TEXTS}>
                        {({data, loading, error}) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;

                            data.getAllTexts.forEach(function (user) {
                                getAllTextMap2[user.TextName] = user.TextValue;
                            });
                            return <WithdrawalPage session={this.state.AllSessionWithSubscription} AllText={getAllTextMap2}/>;
                        }
                        }
                    </Query>

                }/>
                {/*<Route exact path="/testoffer" render={() =>
                    <Query query={GET_ALL_TEXTS}>
                        {({data, loading, error}) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;

                            data.getAllTexts.forEach(function (user) {
                                getAllTextMap2[user.TextName] = user.TextValue;
                            });
                            return <BronzeOffer2 session={this.state.AllSessionWithSubscription} AllText={getAllTextMap2}/>;
                        }
                        }
                    </Query>

                }/>*/}
                <Route exact path="/staking" render={() =>
                    <Query query = {GET_STEAKING_COINS}>
                        {({ data, loading, error }) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;
                            //console.log('data.getSteakingCoins', data.getSteakingCoins); 
                            return <Steaking session={this.state.AllSessionWithSubscription} TokenAmount={data.getSteakingCoins} refetch={this.props.refetch} />;
                        }
                        }
                    </Query>

                } />
                {/*
                <Route exact path="/steaking/:steakid" render={() => <CurrentSteak session={this.state.AllSessionWithSubscription} refetch={this.props.refetch} /> }/>
                */}
                <Route exact path="/staking/:steakid" render={() => 
                    <Query query = {GET_STEAKING_COINS}>
                        {({ data, loading, error }) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;
                            //console.log('data.getSteakingCoins', data.getSteakingCoins); 
                            return <CurrentSteak session={this.state.AllSessionWithSubscription} TokenAmount={data.getSteakingCoins} refetch={this.props.refetch}/>;
                        }
                        }
                    </Query>
                } />

                <Route exact path="/noauth/:logkey?" render={() => <LoginControl refetch={this.props.refetch}/>}/>
                <Route exact path="/r/:logkey?" render={() => <LoginControl refetch={this.props.refetch}/>}/>
                <Route exact path="/news" render={() => <Posts session={this.state.AllSessionWithSubscription} refetch={this.props.refetch}/>}/>
                <Route exact path="/new/:postid" render={() => <CurrentNew session={this.state.AllSessionWithSubscription} refetch={this.props.refetch} /> }/>
            </Switch>
        </React.Fragment>
)
}}

const AppWithSession = withSession(App);


const Root = () => (

    <ApolloProvider client={client}>
        <ApolloHooksProvider client={client}>
            <BrowserRouter>
                <AppWithSession />
            </BrowserRouter>
        </ApolloHooksProvider>
    </ApolloProvider>

);

ReactDOM.render(<Root />,document.getElementById('MainGlobal'));